import { memo } from "react";

import { getVersion } from "@/utils/utility";

import { Box } from "@mui/material";

function PreviewLabel(props) {
  const devType = getVersion("devType");

  if (!devType) {
    return "";
  }

  return (
    <Box
      sx={{
        backgroundColor: "secondary.A400",
        fontWeight: 600,
        fontSize: 11,
        lineHeight: "11px",
        color: "#fff",
        boxShadow: 2,
        display: "inline-block",
        py: 0.5,
        px: 0.75,
        borderRadius: 1,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
      }}
      {...props}
    >
      {getVersion()}
    </Box>
  );
}

export default memo(PreviewLabel);
